import { useTranslation } from "react-i18next";
import { communityStats } from "@/mocks/categories";

export default function CommunityStats() {
  const { t } = useTranslation();

  const stats = [
    { label: t("stat_members"), value: `${(communityStats.members / 10000).toFixed(0)}万+`, icon: "ri-user-heart-line" },
    { label: t("stat_articles"), value: `${(communityStats.articles / 10000).toFixed(1)}万+`, icon: "ri-article-line" },
    { label: t("stat_daily"), value: `${(communityStats.dailyActive / 1000).toFixed(1)}k`, icon: "ri-flashlight-line" },
    { label: t("stat_adoptions"), value: `${(communityStats.adoptions / 1000).toFixed(1)}k+`, icon: "ri-home-heart-line" },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            {t("section_stats")}
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            {t("section_stats_desc")}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="flex flex-col items-center p-6 rounded-lg bg-background-100"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                <i className={`${stat.icon} text-xl`}></i>
              </span>
              <span className="text-2xl md:text-3xl font-heading text-foreground-900 mb-1">
                {stat.value}
              </span>
              <span className="text-sm text-foreground-500">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}